import React from 'react';

interface CanvasGridProps {
  zoom: number;
  pan: { x: number; y: number };
}

export const CanvasGrid: React.FC<CanvasGridProps> = ({ zoom, pan }) => {
  const gridSize = 20 * zoom;
  
  return (
    <div 
      className="absolute inset-0 opacity-20 pointer-events-none"
      style={{
        backgroundImage: 'radial-gradient(circle, #999 1px, transparent 1px)',
        backgroundSize: `${gridSize}px ${gridSize}px`,
        backgroundPosition: `${pan.x % gridSize}px ${pan.y % gridSize}px`
      }}
    />
  );
};